const BASE_URL = 'addresses';

export const PATHS = {
  BASE_URL,
  CREATE_ADDRESS: `${BASE_URL}/create`,
  EDIT_ADDRESS: `${BASE_URL}/edit/:id`,
  ADDRESS_DETAILS: `${BASE_URL}/details/:id`,
};

export const ADDRESS_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  ARCHIVED: 'archived',
};

export const DEFAULT_ADDRESS_DISTANCE_METERS = 50;
